var $ = jQuery;

$(document).on('ready', function(){

    $(document).on('click', '.num-transfers', function() {
        var index = $(this).attr('index');
        $('#field_kqczf').val(index);
        $('.num-transfers').each(function(i, obj) {
            obj.classList.remove('selected');      
            if(obj.getAttribute('index') == index) {
                if (obj.classList.contains('show')) {
                    obj.classList.remove('selected');
                } else {
                    obj.classList.add('selected');    
                }  
            }
       })
    })

    $(document).on('click', '.num-excursions', function() {
        var index = $(this).attr('index');
        $('#field_b90ua').val(index);
        $('.num-excursions').each(function(i, obj) {
            obj.classList.remove('selected');      
            if(obj.getAttribute('index') == index) {
                if (obj.classList.contains('show')) {
                    obj.classList.remove('selected');
                } else {
                    obj.classList.add('selected');    
                }  
            }
       })
    })

    $(document).on('click', '.transfer-btn', function() {
        $('.transfer-submit').trigger('click');
    })

    $(document).on('click', '.excursion-btn ', function() {
        $('.excursion-submit').trigger('click');
    })
})